
import { Component, Vue } from 'vue-property-decorator';

import GlobalMixins from './../mixins';

@Component({
	components: {
	}
})
export default class AdvisorsListView extends GlobalMixins {

}

